BS.DOMReady(function() {
	"use strict";

	var DOM = BS.DOM;

	var pNavWrap = DOM.q(".p-nav-wrap");
	if (!pNavWrap) {
		return;
	}

	ScrollSwitch.register("y", function() {
		var points = [], offset;

		// .p-nav を固定
		offset = pNavWrap.offsetTop;
		if (!offset) {
			return points;
		}
		points.push({ name: "fix", y: offset });
		
		// 下へスクロール
		offset = DOM.q(".tel-sec").offsetTop;
		if (!offset) {
			return points;
		}
		points.push({ name: "bottom", y: offset - 50 });

		return points;
		
	}, function(point) {
		var html = DOM.q("html");

		switch (point) {
		case "fix":
			html.classList.remove("p-nav-bottom");
			html.classList.add("p-nav-fix");
			break;
		case "bottom":
			html.classList.remove("p-nav-fix");
			html.classList.add("p-nav-bottom");
			break;
		default:
			html.classList.remove("p-nav-bottom", "p-nav-fix");
			break;
		}
	});
});
